import { render, staticRenderFns } from "./ServiceInvoice.vue?vue&type=template&id=38c3885a&scoped=true"
import script from "./ServiceInvoice.vue?vue&type=script&lang=js"
export * from "./ServiceInvoice.vue?vue&type=script&lang=js"
import style0 from "./ServiceInvoice.vue?vue&type=style&index=0&id=38c3885a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38c3885a",
  null
  
)

export default component.exports